document.addEventListener("DOMContentLoaded", () => {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {

    if (event.source === "cart-items") {
      Debutify.cart = event.cartData;
      return;
    }

    if (event.source === "product-form") {

      if (Debutify.settings.dbtfy_skip_cart) {
        window.location.href = "/checkout";
        return;
      }

      fetch(`${routes.cart_url}.js`)
        .then((res) => res.json())
        .then((cart) => {
          Debutify.cart = cart;
        })
        .catch((error) => {
          console.error("Cart fetch error:", error);
        });

    }

  });
});